import { supabase } from '../../../services/supabase';
import { TTeamAndUsersCount } from '../types';

export const getTeamsAndUsersCount = async (): Promise<{
  teamsAndUsersCount: TTeamAndUsersCount[];
}> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data, error } = await supabase.rpc('get_users_per_team');
  if (error) {
    throw new Error('Error fetching data');
  }
  return {
    teamsAndUsersCount: (data || []) as TTeamAndUsersCount[],
  };
};
